import { render } from "./opted-out-parent-preview.vue?vue&type=template&id=2330e2e8&scoped=true"
import script from "./opted-out-parent-preview.vue?vue&type=script&lang=js"
export * from "./opted-out-parent-preview.vue?vue&type=script&lang=js"

import "./opted-out-parent-preview.vue?vue&type=style&index=0&id=2330e2e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2330e2e8"]])

export default __exports__